import styled from '@emotion/styled';
import { IconButton } from '@hotjar/hotsauce';

const DeleteIcon = styled(IconButton)`
  position: absolute;
  top: 14px;
  right: 14px;
`;

interface DeleteButtonProps {
  onClick: () => void;
  tooltipText: string;
}

export const DeleteButton = ({ onClick, tooltipText }: DeleteButtonProps): JSX.Element => (
  <DeleteIcon
    tooltipText={tooltipText}
    kind="ghost"
    icon="close"
    onClick={onClick}
    description={tooltipText}
    size="s"
  />
);
